import { sliceActions } from '@store/order/order.slice';

export const self = sliceActions;
